var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContribution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.19281,
    y: 9,
    width: 7.46667,
    height: 3,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7261,
    y: 9,
    width: 7.46667,
    height: 3,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25949,
    y: 13,
    width: 6.4,
    height: 7,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7261,
    y: 13,
    width: 6.4,
    height: 7,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6307 7.97303C11.6307 7.97303 11.8897 4.69933 10.8539 3.72828C9.8181 2.75724 8.13876 2.75724 7.10298 3.72828C6.0672 4.69933 6.0672 6.2737 7.10298 7.24475C8.13876 8.21579 11.6307 7.97303 11.6307 7.97303ZM10.3341 6.75741C10.3341 6.75741 10.4542 5.23851 9.97365 4.78798C9.49308 4.33744 8.71392 4.33744 8.23335 4.78798C7.75278 5.23851 7.75278 5.96897 8.23335 6.4195C8.71392 6.87004 10.3341 6.75741 10.3341 6.75741Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7549 7.97303C12.7549 7.97303 12.4959 4.69933 13.5317 3.72828C14.5675 2.75724 16.2469 2.75724 17.2826 3.72828C18.3184 4.69933 18.3184 6.2737 17.2826 7.24475C16.2469 8.21579 12.7549 7.97303 12.7549 7.97303ZM14.0515 6.75741C14.0515 6.75741 13.9314 5.23851 14.412 4.78798C14.8925 4.33744 15.6717 4.33744 16.1523 4.78798C16.6328 5.23851 16.6328 5.96897 16.1523 6.4195C15.6717 6.87004 14.0515 6.75741 14.0515 6.75741Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContribution);
export default __webpack_public_path__ + "static/media/contribution.bc2e19a543d44c71635d0e64fe6422c0.svg";
export { ForwardRef as ReactComponent };